import React from 'react';
import { BarChart2, X } from 'lucide-react';
import type { Attachment } from '@/hooks/useChatSession';

interface AttachmentChipProps {
  attachment: Attachment;
  onRemove?: () => void;   // present in composer; absent in history
}

export const AttachmentChip: React.FC<AttachmentChipProps> = ({ attachment, onRemove }) => {
  const { title, period, athletes } = attachment;
  const athleteCount = athletes?.length ?? 0;

  return (
    <div
      className="flex items-start gap-2 border border-neutral-300 bg-neutral-100 dark:border-white/15 dark:bg-white/5 px-2 py-1.5"
      data-attachment-chip
    >
      <div className="flex items-center justify-center bg-neutral-200 dark:bg-white/10 p-1 mt-0.5">
        <BarChart2 className="w-4 h-4 text-neutral-700 dark:text-neutral-200" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-xs font-medium text-neutral-900 dark:text-neutral-100 truncate">{title}</div>
        <div className="text-[11px] text-neutral-600 dark:text-neutral-400 truncate">
          {period.start} – {period.end} · {athleteCount} athlete{athleteCount === 1 ? '' : 's'}
        </div>
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="text-neutral-500 hover:text-neutral-900 dark:text-neutral-400 dark:hover:text-neutral-200 p-1"
          aria-label={`Remove ${title}`}
        >
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};
